export const APP_NAME = "CampAd Pro";
export const APP_VERSION = "0.1";
export const APP_URL = "https://campad.pro";
export const APP_VENDOR = "© Macas BV";
export const LOGO_SIZES = { main: "± 400 × 160 px", tent: "± 160 × 160 px" };
